import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gray-50 border-4 border-gray-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-63">
          <div className="absolute top-0 left-0 w-full h-2 bg-green-500" data-id="element-64"></div>

          <div className="flex justify-center mb-6" data-id="element-65">
            <div className="bg-green-100 p-4 rounded-full" data-id="element-66">
              <ShieldCheck className="w-16 h-16 text-green-600" data-id="element-67" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6 uppercase" data-id="element-68">
            🔒 GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="text-xl md:text-2xl text-gray-700 font-medium space-y-4" data-id="element-69">
            <p data-id="element-70">Probalo durante 7 días completos.</p>
            <p data-id="element-71">Si no te funciona, te devolvemos el 100% del dinero.</p>
            <p className="font-bold text-gray-900" data-id="element-72">
              Sin preguntas. Sin riesgo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}